module.exports = __webpack_public_path__ + "static/media/game_controller_02.fc1b517a.JPG";